import { StyleToggle } from "./_static/_styleToggle";
import { FixView } from "./_fixView";
import { HelperGHeader } from "./_helper/_helperGHeader";

//ハンバーガーメニューの開閉用クラス
export class Hamburger extends HelperGHeader {
  constructor(c) {
    super();
    this.btn = c.btn;
    this.menu = c.menu;
    this.overlay = c.overlay;
    this.links = [...this.menu.querySelectorAll("a")];
    this.fixView = new FixView();
  }

  open() {
    this.overlay.open();
    StyleToggle.active([this.btn, this.menu, this.gHeader]);
    this.fixView.fixed();
  }

  close() {
    this.overlay.close();
    StyleToggle.inactive([this.btn, this.menu, this.gHeader]);
    this.fixView.static();
  }
}
